import React from 'react';
import './Financial.css';

interface FinancialProps {
  budgetId: string;
}

const Financial: React.FC<FinancialProps> = ({ budgetId }) => {
  return (
    <div className="financial-container">
      <div className="financial-content">
        <h2>财务收支</h2>
        <p>预算ID: {budgetId}</p>
        <p>财务收支页面开发中...</p>
      </div>
    </div>
  );
};

export default Financial;
